import { render, staticRenderFns } from "./PayServe1.vue?vue&type=template&id=35cc8448&scoped=true"
import script from "./PayServe1.vue?vue&type=script&lang=js"
export * from "./PayServe1.vue?vue&type=script&lang=js"
import style0 from "./PayServe1.vue?vue&type=style&index=0&id=35cc8448&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cc8448",
  null
  
)

export default component.exports